module.exports = __webpack_public_path__ + "assets/5ecbc6b303a7bbb1225891511423e1fe.png";